import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from 'react-modal';
import NumberFormat from 'react-number-format';
import { Portal } from 'react-overlays';
import { Radio, RadioGroup } from 'react-radio-group';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uuid from 'uuid';
import { saveTaxSavingRecord } from '../../actions/employeeActions';
import Checkbox from '../../components/common/checkbox';
import '../../css/react-datepicker.css';
import ButtonDatePicker from '../common/customDatePicker';

const ModalContainer = ({ children }) => {
    const el = document.getElementById('modal-portal');
    return (
        <Portal container={el}>
            {children}
        </Portal>
    )
}

class AddTaxSavingModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            employeeId: this.props.editTaxSaving.length == 0 ? this.props.employeeId : this.props.editTaxSaving[0].EmployeeId,
            taxSavingId: this.props.editTaxSaving.length == 0 ? uuid.v4() : this.props.editTaxSaving[0].TaxSavingId,
            financialYear: this.props.editTaxSaving.length == 0 ? this.props.financialYear : `${this.props.editTaxSaving[0].FinancialYear}`,
            taxSavingType: this.props.editTaxSaving.length == 0 ? '' : `${this.props.editTaxSaving[0].TaxSavingType}`,
            recurringFrequency: this.props.editTaxSaving.length == 0 ? '1' : `${this.props.editTaxSaving[0].RecurringFrequency}`,
            accountNumber: this.props.editTaxSaving.length == 0 ? '' : this.props.editTaxSaving[0].AccountNumber,
            remarks: this.props.editTaxSaving.length == 0 ? '' : this.props.editTaxSaving[0].Remarks,
            taxSavingLineItems: this.props.editTaxSaving.length == 0 ? this.getTaxSavingLineItems(1) : this.props.editTaxSaving[0].TaxSavingLineItems,
            customLineItemCount: this.props.editTaxSaving.length == 0 ? 1 : this.props.editTaxSaving[0].TaxSavingLineItems.length,
            errors: {}
        }
        this.changeDate = this.changeDate.bind(this);
        this.changeValue = this.changeValue.bind(this);
        this.handleChangeCheckBox = this.handleChangeCheckBox.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.copyData = this.copyData.bind(this);
        this.changeCustomLineItemCount = this.changeCustomLineItemCount.bind(this);
    }

    emptyClick() { }

    changeCustomLineItemCount(value) {
        this.setState({
            customLineItemCount: value.floatValue
        });

        this.setState({ taxSavingLineItems: this.getTaxSavingLineItems(value.floatValue) });

    }


    handleValidation() {
        let formIsValid = true;
        let errors = {};
        if (!this.state.taxSavingType) {
            formIsValid = false;
            errors["taxSavingType"] = "Saving Type is required."
        }
        if (!this.state.accountNumber) {
            formIsValid = false;
            errors["accountNumber"] = "Policy/Account No. is required.";
        }
        // if (!this.state.amount) {
        //     formIsValid = false;
        //     errors["amount"] = "Amount is required.";
        // }
        this.setState({ errors: errors });
        return formIsValid
    }

    changeValue(value, index) {
        var taxSavingLineItems = Object.assign([], this.state.taxSavingLineItems)
        taxSavingLineItems[index]["Amount"] = value.floatValue

        this.setState({
            taxSavingLineItems: taxSavingLineItems
        });
    }

    handleChangeCheckBox(index, evt) {
        var taxSavingLineItems = Object.assign([], this.state.taxSavingLineItems)
        taxSavingLineItems[index]["ReceiptSubmitted"] = evt.target.checked

        this.setState({
            taxSavingLineItems: taxSavingLineItems
        });
    }

    changeDate(index, selectedDate) {
        var taxSavingLineItems = Object.assign([], this.state.taxSavingLineItems)
        taxSavingLineItems[index]["SavingDate"] = selectedDate

        this.setState({
            taxSavingLineItems: taxSavingLineItems
        });
    }
    toggleModal() {
        this.props.toggle();
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.handleValidation()) {
            let taxSavingRecords = {
                TaxSavingRecordId: this.props.editTaxSaving.length == 0 ? uuid.v4() : this.props.editTaxSaving[0].TaxSavingRecordId,
                EmployeeId: this.props.editTaxSaving.length == 0 ? this.props.employeeId : this.props.editTaxSaving[0].EmployeeId,
                FinancialYear: this.props.financialYear,
                TaxSavingType: this.state.taxSavingType,
                RecurringFrequency: this.state.recurringFrequency,
                AccountNumber: this.state.accountNumber,
                Remarks: this.state.remarks,
                CreatedBy: this.props.userId,
                TaxSavingLineItems: this.getTaxSavingLineItems(this.state.recurringFrequency),
            }

            this.props.saveTaxSavingRecord(taxSavingRecords, this.props.employeeId, this.props.financialYear);
            this.toggleModal();
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    getTaxSavingLineItems(recurringFrequency, changeState) {
        if (recurringFrequency === '99' || recurringFrequency === 99) {
            recurringFrequency = this.state.customLineItemCount;
        }
        recurringFrequency = parseInt(recurringFrequency);
        let months = [];
        const taxSavingLineItems = this.state && this.state.taxSavingLineItems ? this.state.taxSavingLineItems : [];

        for (var i = 0; i < recurringFrequency; i++) {
            let receiptSubmitted = false;
            let frequencyDate;
            let amount = '';
            let lineItemId = uuid.v4();
            let monthIndex = 0;
            let financialYearDate = new Date(Date.UTC(this.props.financialYear, 3, 1));
            switch (recurringFrequency) {
                case 2: monthIndex = i * 6; break;
                case 4: monthIndex = i * 3; break;
                default: monthIndex = i; break;
            }
            if (!frequencyDate) {
                if (i !== 0) {
                    frequencyDate = new Date(moment(financialYearDate).add(monthIndex, 'months'));
                } else {
                    frequencyDate = financialYearDate;
                }
            }
            if (taxSavingLineItems && taxSavingLineItems.length > 0 && taxSavingLineItems[i]) {
                lineItemId = taxSavingLineItems[i].LineItemId ? taxSavingLineItems[i].LineItemId : (taxSavingLineItems[i].TaxSavingRecordId ? taxSavingLineItems[i].TaxSavingRecordId : lineItemId)
                frequencyDate = taxSavingLineItems[i].SavingDate ? taxSavingLineItems[i].SavingDate : frequencyDate;
                amount = taxSavingLineItems[i].Amount;
                receiptSubmitted = taxSavingLineItems[i].ReceiptSubmitted;
            }
            months.push({
                LineItemId: lineItemId,
                SavingDate: frequencyDate, Amount: amount, ReceiptSubmitted: receiptSubmitted
            });
        }

        if (changeState) {
            this.setState({ taxSavingLineItems: months });
        }
        return months;
    }

    copyData(value) {
        let taxSavingLineItems = Object.assign([], this.state.taxSavingLineItems)
        _.map(taxSavingLineItems, (item, index) => {
            if (index !== 0) {
                item['Amount'] = value;
            }
        })

        this.setState({
            taxSavingLineItems: taxSavingLineItems
        });
    }

    renderFrequency() {
        var _this = this;
        const recurringFrequency = parseInt(this.state.recurringFrequency);
        var taxSavingLineItems = Object.assign([], this.state.taxSavingLineItems)
        if (recurringFrequency <= 0) return '';
        let lineItemsCount = recurringFrequency;
        if (recurringFrequency === 99) {
            lineItemsCount = this.state.customLineItemCount;
        }
        return (
            Array(lineItemsCount).fill().map(function (name, index) {
                let frequencyValue;
                let frequencyDate;
                let receiptSubmitted;
                if (taxSavingLineItems[index]) {
                    frequencyValue = taxSavingLineItems[index].Amount;
                    frequencyDate = new Date(taxSavingLineItems[index].SavingDate);
                    receiptSubmitted = taxSavingLineItems[index].ReceiptSubmitted;
                }
                const isValidValue = frequencyValue !== undefined && frequencyValue !== null && frequencyValue !== '';

                return (
                    <div className="form frequency-list" key={index}>
                        <div className="form-group row">
                            <div className='col-sm-3 left'>
                                <ButtonDatePicker value={frequencyDate} onChange={_this.changeDate.bind(this, index)} />
                                {/* <DatePicker className='form-control' selected={frequencyDate}
                                    onChange={_this.changeDate.bind(this, index)}
                                    autoComplete={0} dateFormat='dd-MMM-yyyy'
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    placeholderText="dd-MMM-yyyy" id="inputDate" /> */}
                            </div>
                            <div className="col-sm-3" >
                                <NumberFormat className={"form-control"} style={{ textAlign: 'right' }}
                                    decimalScale={2}
                                    allowNegative={false} thousandSeparator={','} width={90} value={(isValidValue) ? frequencyValue : ''}
                                    onValueChange={(value) => {
                                        _this.changeValue(value, index)
                                    }}
                                />
                            </div>
                            <div className='col-sm-2 left' style={{ padding: '5px 15px' }}>
                                <div style={{ lineHeight: 1 }}>
                                    <Checkbox checked={receiptSubmitted} onChange={_this.handleChangeCheckBox.bind(this, index)} />
                                </div>
                            </div>
                            {(recurringFrequency > 1 && index === 0) &&
                                <div className='col-sm-2 left'>
                                    <div style={{ lineHeight: 1 }}>
                                        {(isValidValue) &&
                                            <div className="btn btn-default ir-btn-neutral-outline"
                                                style={{ padding: '.025rem .3rem' }} data-toggle="tooltip" data-placement="bottom" title="Copy amount"
                                                onClick={_this.copyData.bind(this, frequencyValue)}
                                            >
                                                <i className="fa fa-copy"></i>
                                            </div>
                                        }
                                        {(!isValidValue) &&
                                            <div className="btn btn-default ir-btn-neutral-outline disabled" style={{ padding: '.025rem .3rem' }} data-toggle="tooltip" data-placement="bottom" title="Copy amount">
                                                <i className="fa fa-copy"></i>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div >
                );
            })
        )
    }

    onRadioChange(value, event) {
        this.setState({
            recurringFrequency: value
        });
        if (value !== '99') {
            this.setState({ taxSavingLineItems: this.getTaxSavingLineItems(value) });
        }
        //this.updateDimensions(value);
    };

    updateDimensions(value) {
        // const recurringFrequency = parseInt(value);
        // const innerHeight = window.parent.innerHeight;
        // var dialogHeight = (innerHeight * 10 * recurringFrequency) / 100;
        // var modalBodyHeight = (innerHeight * 10 * recurringFrequency) / 100;
        // var modalBodyData = document.getElementById('addTaxSavingModal').getElementsByClassName("modal-body");
        // var modalContentData = document.getElementById('addTaxSavingModal').getElementsByClassName("modal-content");
        // if (modalBodyData.length > 0) {
        //     if (recurringFrequency > 2) {
        //         modalBodyData[0].style.height = modalBodyHeight + 'px';
        //     } else {
        //         modalBodyData[0].style.height = (innerHeight * 40) / 100 + 'px';
        //     }
        // }
        // if (modalContentData.length > 0) {
        //     if (recurringFrequency > 2) {
        //         modalContentData[0].style.minHeight = dialogHeight * recurringFrequency + 'px';
        //         modalContentData[0].style.maxHeight = (innerHeight * 95) / 100 + 'px';
        //     } else {
        //         modalContentData[0].style.height = (innerHeight * 60) / 100 + 'px';
        //     }
        // }
    }

    renderFrequencyHeader() {
        return (
            <div className="form">
                <div className="row" style={{ textAlign: "right" }}>
                    <div className='col-sm-3'>
                        <label className="left">Date</label>
                    </div>
                    <div className="col-sm-3">
                        <label className="left">Amount</label>
                    </div>
                    <div className='col-sm-3'>
                        <label className="left">Receipt</label>
                    </div>
                </div>
            </div>
        )
    }

    renderFrequencyData() {
        const totalAmount = this.state.taxSavingLineItems.length > 0 ? _.sumBy(this.state.taxSavingLineItems, 'Amount') : 0;
        return (
            <div style={{ borderRadius: 4, backgroundColor: '#f6f7f7', marginTop: '5px', padding: '0 12px' }}>
                <div>
                    {this.renderFrequencyHeader()}
                    {this.renderFrequency()}

                    <hr className='v-line' style={{ border: '1px solid rgb(227, 232, 238)' }} />

                    <div className="mgT5 pdB5">
                        <div className="row">
                            <label className="col-sm-3 col-form-label">Total Amount</label>
                            <div className="col-sm-3">
                                <input type="text" id="txtTotalAmount" style={{ lineHeight: '0.5', border: 'none', textAlign: "right" }} value={totalAmount} disabled className="form-control" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    afterOpenModal() {
        this.updateDimensions(this.state.recurringFrequency);
    }

    render() {
        const usersData = this.props.employeeData;
        const isEdit = this.props.isEdit;
        const recurringFrequency = this.state.recurringFrequency;
        return (
            <ModalContainer>
                <Modal isOpen={this.props.isOpen} onAfterOpen={this.afterOpenModal} onRequestClose={this.toggleModal} ariaHideApp={false} className='modal-style'>
                    <div id='addTaxSavingModal' >
                        <div className={'modal fade-in'} style={{ display: 'block' }}>
                            <div className={'modal-dialog modal-wd95pc-mwd-618'}>
                                <form onSubmit={this.handleSubmit}>
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            {
                                                <h4 style={{ marginRight: "auto" }}>
                                                    <i style={{ cursor: 'unset' }} className={'fa ' + (isEdit ? 'fa-edit' : 'fa-plus-square')}></i>
                                                    &nbsp;{(isEdit && this.props.isAdmin ? this.props.empName : this.props.userName)} ({this.props.fYearText})
                                                        {/* <small>policy no. {this.state.accountNumber}</small> */}
                                                </h4>
                                            }
                                            <div className='inline-block right pdT9'><span id='spnCancel' className='cursor-pointer v-bold' onClick={() => this.props.toggle()}>X</span></div>
                                        </div>
                                        <div className="modal-body">
                                            <div>
                                                <div className="form-group row">
                                                    <label className="col-sm-4 col-form-label">Saving Type</label>
                                                    <div className="col-sm-8">
                                                        <select className="form-control" onChange={this.handleChange} value={this.state.taxSavingType} name="taxSavingType" >
                                                            {
                                                                usersData.taxSavingTypes.map(function (item, index) {
                                                                    return <option key={index} value={item.Value}>{item.Text}</option>
                                                                })
                                                            }
                                                        </select>
                                                        <small style={{ color: "red" }}>{this.state.errors["taxSavingType"]}</small>
                                                    </div>
                                                </div>

                                                <div className="form-group row">
                                                    <label className="col-sm-4 col-form-label">Policy/Account No.</label>
                                                    <div className="col-sm-8">
                                                        <input type="text" id="txtAccount" value={this.state.accountNumber} onChange={this.handleChange} maxLength='100' name="accountNumber" className="form-control" />
                                                        <small style={{ color: "red" }}>{this.state.errors["accountNumber"]}</small>
                                                    </div>
                                                </div>

                                                <div className="form-group row">
                                                    <label htmlFor='txtRemarks' className="col-sm-4 col-form-label">Remarks</label>
                                                    <div className="col-sm-8">
                                                        <input type="text" id="txtRemarks" maxLength='100' name="remarks" value={this.state.remarks} onChange={this.handleChange} className="form-control" />
                                                    </div>
                                                </div>

                                                <label className="manageTopicLabel pdL0 pdT0">{'Select frequency type'}</label>
                                                <div className="v-form-line-container pdL0 pdR0">
                                                    <div style={{ width: '100%' }}>
                                                        <div className='left'>
                                                            <RadioGroup className="left mgL25" name={"radioGroupFrequency" + this.props.entityId} selectedValue={recurringFrequency}
                                                                onChange={this.props.isEdit ? this.emptyClick : this.onRadioChange.bind(this)}>
                                                                <div className={recurringFrequency !== '1' && isEdit ? 'disable-item' : ''} style={{ position: 'relative', display: 'inline-block' }} onClick={this.props.isEdit ? this.emptyClick : this.onRadioChange.bind(this, '1')}>
                                                                    <Radio value="1" className='ht15' style={{ width: '20px', position: 'absolute', cursor: 'pointer' }} />
                                                                    <div className='inline-block pdL20 pdR10' style={{ cursor: 'pointer' }}>{'Yearly'} </div>
                                                                </div>
                                                                <div className={recurringFrequency !== '2' && isEdit ? 'disable-item' : ''} style={{ position: 'relative', display: 'inline-block' }} onClick={this.props.isEdit ? this.emptyClick : this.onRadioChange.bind(this, '2')}>
                                                                    <Radio value="2" className='ht15' style={{ width: '20px', position: 'absolute', cursor: 'pointer' }} />
                                                                    <div className='inline-block pdL20 pdR10' style={{ cursor: 'pointer' }}>{'Half-Yearly'}</div>
                                                                </div>
                                                                <div className={recurringFrequency !== '4' && isEdit ? 'disable-item' : ''} style={{ position: 'relative', display: 'inline-block' }} onClick={this.props.isEdit ? this.emptyClick : this.onRadioChange.bind(this, '4')}>
                                                                    <Radio value="4" className='ht15' style={{ width: '20px', position: 'absolute', cursor: 'pointer' }} />
                                                                    <div className='inline-block pdL20 pdR10' style={{ cursor: 'pointer' }}>{'Quarterly'}</div>
                                                                </div>
                                                                <div className={recurringFrequency !== '12' && isEdit ? 'disable-item' : ''} style={{ position: 'relative', display: 'inline-block' }} onClick={this.props.isEdit ? this.emptyClick : this.onRadioChange.bind(this, '12')}>
                                                                    <Radio value="12" className='ht15' style={{ width: '20px', position: 'absolute', cursor: 'pointer' }} />
                                                                    <div className='inline-block pdL20 pdR10' style={{ cursor: 'pointer' }}>{'Monthly'}</div>
                                                                </div>
                                                                <div style={{ position: 'relative', display: 'inline-block' }} onClick={this.props.isEdit ? this.emptyClick : this.onRadioChange.bind(this, '99')}>
                                                                    <Radio value="99" className='ht15' style={{ width: '20px', position: 'absolute', cursor: 'pointer' }} />
                                                                    <div className='inline-block pdL20 pdR10' style={{ cursor: 'pointer' }}>{'Custom'}</div>
                                                                </div>
                                                                {recurringFrequency === '99' &&
                                                                    <div style={{ width: '50px', display: 'inline-block' }}>
                                                                        <NumberFormat className={"form-control"} decimalScale={0}
                                                                            allowNegative={false} width={50} value={this.state.customLineItemCount ? this.state.customLineItemCount : 1}
                                                                            onValueChange={(value) => {
                                                                                this.changeCustomLineItemCount(value)
                                                                            }}
                                                                        />
                                                                    </div>
                                                                }
                                                            </RadioGroup>
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.renderFrequencyData()}
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button id="btnSave" className="btn btn-success" data-placement="top" title="Save">Save</button>
                                            <button id="btnWorklogCancel" className="btn btn-default" data-toggle="tooltip" data-placement="top" title="Cancel" onClick={() => this.props.toggle()} data-dismiss="modal">Cancel</button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </Modal>
            </ModalContainer>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ saveTaxSavingRecord }, dispatch)
}
export default connect(null, mapDispatchToProps)(AddTaxSavingModal)

